import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { IProjectContractStage } from 'src/app/project-display/interfaces/IProjectContractStage';
import { ContractComponent } from '../contract/contract.component';
import { IProjectContract } from 'src/app/project-display/interfaces/IProjectContract';
import { IProjectSummary } from 'src/app/project-display/interfaces/IProjectSummary';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  selector: 'eic-contract-stage',
  templateUrl: './contract-stage.component.html',
  styleUrl: './contract-stage.component.scss'
})
export class ContractStageComponent implements OnInit {

  @Input() public stage: IProjectContractStage;
  @Input() currentProject: { id: number, name: string };
  @Output() contract_selected = new EventEmitter();
  @Output() project_selected = new EventEmitter();

  @ViewChildren(ContractComponent) contracts: QueryList<MatExpansionPanel>;

  selectedValue = "";

  onToggleChange(event: MatButtonToggleChange) {
    const selectedValue = event.value;
    if (selectedValue === 'open') {
      this.openAll();
    } else if (selectedValue === 'close') {
      this.closeAll();
    }
  }
  
  openAll() {
    this.contracts.forEach(contract => contract.open());
  }

  closeAll() {
    this.contracts.forEach(contract => contract.close());
  }

  contractSelected(contract: IProjectContract) {
    this.contract_selected.emit(contract)
  }
  projectSelected(project: IProjectSummary) {
    this.project_selected.emit(project)
  }

  ngOnInit(): void {
    this.selectedValue = "close";
  }
}
